import React, { useState, useEffect } from 'react'
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
// import { url } from "../../App";
import { Bar } from 'react-chartjs-2';
import Cookies from 'js-cookie';

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

 ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const BarChart = () => {
  const [open, setOpen] = React.useState(false);
      //eslint-disable-next-line
  const [chart, setChart] = useState([])
  const token = Cookies.get('Token');
  const email = Cookies.get('Email');
  
  useEffect(() => {
    setOpen(true);
      axios
        .get("https://jsonplaceholder.typicode.com/comments")
          
        .then((res) => {
          setOpen(false);
          //  console.log(res);
            setChart(res?.data);
        })
        .catch((err) => {
          setOpen(false);
          // console.log(err);
          toast.error(err.message);
        });
    }, [email,token]);

  const data = {
    // labels: chart?.map(x => x.postId),  //x-axis
    labels: ['All','Branch 1', 'Branch 2', 'Branch 3', 'Branch 4', 'Branch 5'],
    datasets: [
      {
      label: `LAP`,
      // data: chart?.map(x => x.id), //y-axis
      data: [100, 10, 40, 25, 5, 20],
      backgroundColor: [
        '#5B9BD5'
      ],
      borderWidth: 1,
    },
    {
      label: `Dairy`,
      // data: chart?.map(x => x.id), //y-axis
      data: [350, 100, 150, 40, 25, 35],
      backgroundColor: [
        '#ED7D31',
      ],
      borderWidth: 1,
    },
    {
      label: `BL`,
      // data: chart?.map(x => x.id), //y-axis
      data: [175, 10, 65, 20, 50, 30],
      backgroundColor: [
        '#A5A5A5'
      ],
      borderWidth: 1,
    },
  ]
  };

  var options = {
    maintainAspectRatio: false,
    responsive:true,
    scales: {
    },
    legend: {
      labels: {
        fontSize: 25,
      },
    },
  }

  return (
    <div>
      <Bar
        data={data}
        options={options}
        height={400}
      />
      <ToastContainer />
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={open}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
    </div>
  )
}

export default BarChart